import { render, staticRenderFns } from "./PropertyInsurance.vue?vue&type=template&id=3eb8164b"
import script from "./PropertyInsurance.vue?vue&type=script&lang=js"
export * from "./PropertyInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports